import React from "react";
import { Beforeunload } from "react-beforeunload";
import { Progress, Header } from "semantic-ui-react";

export const ProjectUploadProgress = ({ value }) => (
  <Beforeunload onBeforeunload={() => "onBeforeUnload"}>
    <Header sub content="Uploading: " />
    <Progress percent={value} progress="percent" precision={0} indicating />
  </Beforeunload>
);

export const ProjectRecordedProgress = ({ value, total }) => (
  <Progress
    value={value}
    total={total}
    progress="percent"
    precision={0}
    indicating
  />
);
